import { render } from "./Akhir.vue?vue&type=template&id=513876f6"
import script from "./Akhir.vue?vue&type=script&lang=js"
export * from "./Akhir.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__